<template>
  <div class="order-allow-deny">
    <div style="overflow: hidden">
      <vs-row>
        <vs-col vs-justify="center" vs-align="center" vs-w="6">
          مدت زمان ارسال سفارش: ( دقیقه )
          <vs-input
            v-model="preparationTime"
            class="w-100 mt-1"
            @input="isTouched = true"
          />
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import providerApiService from "../../services/api/ProviderApiService";
import { getMoment } from "../../helpers/Functions";

const DEFAULT_ORDER_DELIVERY_TIME_KEY = "default-order-delivery-time";
const FALLBACK_PREPARATION_TIME = "45";

// the setting does not change while the panel is open, so the request is
// cached per provider instead of being repeated for every mounted instance
const defaultDeliveryTimeRequests = {};

const getDefaultOrderDeliveryTime = (providerId) => {
  if (!defaultDeliveryTimeRequests[providerId]) {
    defaultDeliveryTimeRequests[providerId] = providerApiService
      .getSettings(providerId)
      .then((settings) => {
        const setting = settings?.find(
          (item) => item.key === DEFAULT_ORDER_DELIVERY_TIME_KEY
        );

        const minutes = Number(setting?.value);

        return Number.isFinite(minutes) && minutes > 0 ? String(minutes) : null;
      })
      .catch(() => null);
  }

  return defaultDeliveryTimeRequests[providerId];
};

export default {
  name: "PreparationTime",
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  created() {
    const providerId = this.currentProvider?.id;

    if (!providerId) return;

    // fill the field with the shop's default delivery time while the user
    // has not typed anything
    getDefaultOrderDeliveryTime(providerId).then((minutes) => {
      if (!minutes || this.isTouched) return;

      this.preparationTime = minutes;
    });
  },
  methods: {
    getTime() {
      const { preparationTime } = this;
      const time = getMoment()
        .add(preparationTime, "minute")
        .format("YYYY-MM-DD HH:mm:ss");
      return time;
    },
  },
  data() {
    return {
      preparationTime: FALLBACK_PREPARATION_TIME,
      isTouched: false,
    };
  },
};
</script>
